enum InterestType {
  FLOATING = 'FLOATING',
  FIXED = 'FIXED',
}

export default InterestType;
